import axios from "axios";

export default axios.create({
  baseURL: "https://ecomapi.devstage.ru/api"
});